import { useState, useEffect, useCallback } from 'react'

interface Toast {
  id: string
  title: string
  subtitle: string
  action?: () => void
  actionLabel?: string
}

let showToastFn: ((toast: Omit<Toast, 'id'>) => void) | null = null

export function fireToast(toast: Omit<Toast, 'id'>) {
  showToastFn?.(toast)
}

export default function NotificationToast() {
  const [toast, setToast] = useState<Toast | null>(null)

  const show = useCallback((t: Omit<Toast, 'id'>) => {
    const id = crypto.randomUUID()
    setToast({ ...t, id })

    // Try browser notification if tab is backgrounded
    if (document.hidden && Notification?.permission === 'granted') {
      void new Notification(`SilkVoice — ${t.title}`, { body: t.subtitle })
    }

    // Auto-dismiss after 6 seconds
    setTimeout(() => {
      setToast(prev => prev?.id === id ? null : prev)
    }, 6000)
  }, [])

  useEffect(() => {
    showToastFn = show
    return () => { showToastFn = null }
  }, [show])

  return (
    <div className={`notif-toast${toast ? ' show' : ''}`}>
      <div className="notif-icon">
        <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
      </div>
      <div className="notif-body">
        <div className="notif-title">{toast?.title ?? ''}</div>
        <div className="notif-sub">{toast?.subtitle ?? ''}</div>
      </div>
      {toast?.action && (
        <button className="notif-cta" onClick={toast.action}>
          {toast.actionLabel ?? 'View'}
        </button>
      )}
    </div>
  )
}
